import React, { Component, Fragment } from "react";
import api from "../../../../common/app/helpers/fileManager-service";
import { connect } from "@common/components/base.component";
import documentoSelector from "../store/documento.selectors";
import solicitacaoSelector from "../../solicitacao/store/solicitacao.selectors";
import documentoActions from "../store/documento.actions";
import autoBind from "react-autobind";
import Panel from "@common/externos/components/panel/panel.component";
import CamposDinamicosAnexos from '@common/components/camposDinamicosAnexos/components/camposDinamicosAnexos.component';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      camposObrigatorios: []
    };
  }

  setAccordion() {
    this.setState({ showAccordion: !this.state.showAccordion });
  }

  handleChangeAnexo(anexo) {
    this.props.documentoActions.setAnexo(anexo);
  }

  handleChangeAnexoCustomizado(anexoCustomizado) {
    this.props.documentoActions.setAnexoCustomizado(anexoCustomizado);
  }

  render() {
    let { isView, prefix, disableAll, documentoSelector } = this.props;
    isView = disableAll ? true : isView;
    prefix = disableAll ? "V" : "R";

    const { documento } = documentoSelector;
    const { anexo, anexoCustomizado } = documento;

    return (
      <Panel title={"Arquivos e Anexos"} defaultExpanded={false}>
        <div
          style={{
            borderLeft: "5px solid #E0E0E0",
            paddingLeft: 12
          }}
        >
          <h4>
            Anexos
          </h4>
          <h6 className={"mb-3"}>
            Os formatos permitidos são: doc | txt | xls | xlsx | pdf | docx |
            jpg | jpeg | jpe | gif | bmp | png
          </h6>
          <CamposDinamicosAnexos
            state={{anexo}}
            service={api.downloadPath}
            isView={isView}
            prefix={prefix}
            TamanhoNomeArquivo={50}
            TipoCustomizado={false}
            isExterno={true}
            extensionsAllowed={
              "doc|txt|xls|xlsx|pdf|docx|jpg|jpeg|jpe|gif|bmp|png"
            }
            onChange={_anexo => this.handleChangeAnexo(_anexo)}
          />
        </div>

        <div
          className={"mt-2"}
          style={{ borderLeft: "5px solid #E0E0E0", paddingLeft: 12 }}
        >
          {anexoCustomizado && anexoCustomizado.length > 0 && <h4 className={"mb-3"}>Outros Anexos</h4>}
          <CamposDinamicosAnexos
            state={{anexoCustomizado}}
            service={api.downloadPath}
            prefix={prefix}
            isView={isView}
            TamanhoNomeArquivo={50}
            TipoCustomizado={true}
            isExterno={true}
            extensionsAllowed={
              "doc|txt|xls|xlsx|pdf|docx|jpg|jpeg|jpe|gif|bmp|png"
            }
            onChange={_anexoCustomizado => this.handleChangeAnexoCustomizado(_anexoCustomizado)}
          />
        </div>
      </Panel>
    );
  }
}

export default connect({
  actions: {
    documentoActions
  },
  selectors: {
    documentoSelector,
    solicitacaoSelector
  }
})(Container);
